<button
  mat-raised-button
  class="update-button"
  [matMenuTriggerFor]="menu"
  *saAllowedAccountRoles="[1, 2, 9, 10]"
  saAutomatedSelector="well__update"
>
  <div class="update-button-inner"><mat-icon>edit</mat-icon> Update</div>
</button>

<mat-menu #menu="matMenu" xPosition="before" backdropClass="lmo-frac-home-update" class="menu-panel-class">
  <a
    mat-menu-item
    class="menu-button"
    [routerLink]="['./', 'lmo_frac_home_modal', 'complete_current_stage']"
    [disabled]="(currentFrac$ | async).completed"
  >
    <div class="menu-button-inner">
      <span>Complete Stage {{ (currentFracCurrentStage$ | async)?.stageNumber }}</span>
      <div class="circle">
        <img src="/assets/icons/complete-stage.svg" />
      </div>
    </div>
  </a>
  <a
    mat-menu-item
    class="menu-button"
    [routerLink]="['./', 'lmo_frac_home_modal', 'create_loader_report']"
    saAutomatedSelector="frac_detail__update_loader_status"
  >
    <div class="menu-button-inner">
      <span>Loader Status</span>
      <div class="circle">
        <img src="/assets/icons/loader.svg" />
      </div>
    </div>
  </a>
  <a
    mat-menu-item
    class="menu-button"
    [routerLink]="['./', 'lmo_frac_home_modal', 'lmo_loader_hours']"
    saAutomatedSelector="frac_detail__update_loader_status"
  >
    <div class="menu-button-inner">
      <span>Loader Non-Operational Hours</span>
      <div class="circle">
        <mat-icon>access_time</mat-icon>
      </div>
    </div>
  </a>
  <a
    mat-menu-item
    class="menu-button"
    [routerLink]="['./', 'lmo_frac_home_modal', 'create_frac_report']"
    saAutomatedSelector="frac_detail__update_well_status"
  >
    <div class="menu-button-inner">
      <span>Well Status</span>
      <div class="circle">
        <img src="/assets/icons/lmo-rig.svg" />
      </div>
    </div>
  </a>
  <a mat-menu-item class="menu-button" [routerLink]="['./', 'lmo_frac_home_modal', 'reset_current_stock']">
    <div class="menu-button-inner">
      <span>Reset Current Stock</span>
      <div class="circle">
        <img src="/assets/icons/complete-stage.svg" />
      </div>
    </div>
  </a>
</mat-menu>
